import { Map } from 'immutable';
import Boxes from './scenes/Boxes';

export default new Map({
    /** Banc de test des Boxes */
    '/boxes': {
        must_logged: true,
        component: Boxes,
        right: 'userList'
    }
});



// WEBPACK FOOTER //
// ./environments/testbench/routes.js